import React from 'react'
import useTranslation from 'next-translate/useTranslation'

import GHref from 'tennders-market/common/components/element/GHref'
import MultipleSalesInvoiceExtraCostRow
  from 'tennders-finance/sales-invoice/components/multiple-sales-invoice/MultipleSalesInvoiceExtraCostRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

const MultipleSalesInvoiceExtraCostsTable = (props) => {
  const {
    extraCostsLines,
    extraCostsErrors,
    onExtraCostsFormChange,
    removeExtraCostsLine,
    onNewAddExtraCostsLine,
    companyId,
    defaultVat,
    reversedVat,
    isCreditNote
  } = props
  const { t } = useTranslation()

  return (
    <>
      <div className="hr"></div>
      <p className="text-uppercase mb-10 ls-1">
        <strong>ADDITIONAL EXPENSES</strong>
      </p>

      <table
        className="tennders-table-zebra"

      >
        <thead>
          <tr>
            <th />
            <th>#</th>
            <th>Target</th>
            <th>Concept</th>
            <th>Amount</th>
            <th>Vat Percentage</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {extraCostsLines.map((extraCost, index) => (
            <MultipleSalesInvoiceExtraCostRow
              reversedVat={reversedVat}
              initialErrors={extraCostsErrors}
              index={index}
              isCreditNote={isCreditNote}
              keyIndex={extraCost.id}
              key={extraCost.id}
              companyId={companyId}
              defaultVat={defaultVat}
              onFormChange={onExtraCostsFormChange}
              removeLine={removeExtraCostsLine}
            />
          ))}
        </tbody>
      </table>

      {!isCreditNote && (
        <GHref
          className="btn-border medium standard-btn mt-16"
          onClick={() => onNewAddExtraCostsLine()}
        >
          <span className="mr-6">
            <FontAwesomeIcon icon={faPlus} />
          </span>
          {t('multiple_sales_invoice:add_expense')}
        </GHref>
      )}

    </>
  )
}

export default React.memo(MultipleSalesInvoiceExtraCostsTable)
